export const DEFAULT_WIDTH = '400';

export const DEFAULT_HEIGHT = '400';

export const DEFAULT_REVEAL_PERCENTAGE = '50';

export default {
  DEFAULT_WIDTH,
  DEFAULT_HEIGHT,
  DEFAULT_REVEAL_PERCENTAGE,
};
